import shamsiToMiladi from "./_shamsiToMiladi";
import miladiToShamsi from "./_miladiToShamsi";
const moment = {
  shamsiToMiladi,
  miladiToShamsi,
};
export default moment;
